// webpack-chunk-shim.js — Bridge between webpack-compiled section files and clean globals
// The original vendor.js was a webpack bundle providing chunk 4121 with shared modules.
// Our clean vendor.js doesn't have webpack. This shim provides the chunk so that
// any remaining webpack-compiled section files (e.g. product-quick-view) can initialize.
(function () {
  'use strict';

  var chunks = self.webpackChunkreflect_boilerplate = self.webpackChunkreflect_boilerplate || [];

  chunks.push([[4121], {
    // Module 67367 — CartAPI exports consumed by webpack-compiled sections
    67367: function (module, exports, __webpack_require__) {
      __webpack_require__.r(exports);
      __webpack_require__.d(exports, {
        cartAdd: function () { return cartAdd; },
        cartChange: function () { return cartChange; },
        cartGetQuantityOfVariant: function () { return cartGetQuantityOfVariant; },
        printMoney: function () { return printMoney; },
        queryReplaceParam: function () { return queryReplaceParam; },
        t: function () { return t; }
      });

      function cartAdd(data) {
        if (!window.Cart) return Promise.reject('Cart not loaded');
        // webpack sections call cartAdd({ items: [{ id, quantity, properties }] })
        var items = data.items || [];
        if (items.length === 0) return Promise.reject('No items');
        var item = items[0];
        return window.Cart.add(item.id, item.quantity || 1, item.properties || {});
      }

      function cartChange(data) {
        if (!window.Cart) return Promise.reject('Cart not loaded');
        return window.Cart.change(data.id, data.quantity);
      }

      // Synchronous — reads from cart cache if available
      function cartGetQuantityOfVariant(variantId) {
        if (window.Cart && window.Cart.data) {
          var items = window.Cart.data.items || [];
          for (var i = 0; i < items.length; i++) {
            if (items[i].variant_id === variantId) return items[i].quantity;
          }
        }
        return 0;
      }

      function printMoney(cents) {
        return window.printMoney ? window.printMoney(cents) : '$' + (cents / 100).toFixed(2);
      }

      function queryReplaceParam(key, value) {
        if (window.queryReplaceParam) return window.queryReplaceParam(key, value);
        var url = new URL(window.location.href);
        if (value === null || value === undefined || value === '') {
          url.searchParams.delete(key);
        } else {
          url.searchParams.set(key, value);
        }
        return url.pathname + url.search;
      }

      function t(key) {
        return window.t ? window.t(key) : key;
      }
    },

    // Stub modules — section registrations handled by our standalone JS files
    // These modules would have registered sections via the internal webpack Section class,
    // but our clean section-base.js + standalone scripts handle all registrations now.
    71517: function () {},
    93777: function () {},
    14190: function () {},
    12359: function () {},
    86097: function () {},
    17273: function () {},
    27415: function () {},
    19929: function () {},
    37583: function () {},
    55122: function () {},
    20230: function () {},
    57268: function () {},
    79733: function () {}
  }]);
})();
